import {isDevMode} from '@angular/core';

export class GoTourSettings {

  private _settings = {
    dev: {
      api_host: 'gotour.api.dev.avidratings.com',
      key: atob('YTFzMmQzZjQ='),
      api_version: '/v1.0',
      gotour_host: 'dev.gotourhd.com'
    },
    prod: {
      api_host: 'gotour.api.avidratings.com',
      key: atob('eWVpTmc1b29zZWluZ2VlU2h1MHQ='),
      api_version: '/v1.0',
      gotour_host: 'gotourhd.com'
    }
  };

  currentSettings() {
    return isDevMode() ? this._settings.dev : this._settings.prod;
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/gotour-settings.ts